import { useEffect, useRef } from "react";
import { useLocation } from "react-router";

export function ScrollToTop() {
  const { pathname } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    // Skip scroll-to-top for admin routes to preserve navigation UX
    const isAdminRoute = pathname.startsWith("/admin");
    const wasAdminRoute = prevPathname.current.startsWith("/admin");
    
    // Only scroll to top when:
    // 1. Navigating between non-admin routes, OR
    // 2. Entering admin from non-admin (but not navigating within admin)
    if (!isAdminRoute || (isAdminRoute && !wasAdminRoute)) {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
    
    prevPathname.current = pathname;
  }, [pathname]);

  return null;
}
